/* Native details work without JavaScript. Editor block selection reveals its answer,
   and a link to a question's anchor (e.g. #exchanges) opens that question. */
(() => {
  if (window.torqueConfidenceEditorBound) return;
  window.torqueConfidenceEditorBound = true;
  document.addEventListener('shopify:block:select', (event) => {
    const question = event.target.closest?.('.tqc-question');
    if (question) question.open = true;
  });
  const openFromHash = () => {
    let id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;
    // Old links used #confidence-returns etc. (now #returns) and #support (now #contact).
    const legacy = id.replace(/^confidence-/, '').replace(/^support$/, 'contact');
    if (!document.getElementById(id) && legacy !== id && document.getElementById(legacy)) {
      id = legacy;
      history.replaceState(history.state, '', `#${id}`);
      document.getElementById(id).scrollIntoView({ block: 'start' });
    }
    const target = document.getElementById(id);
    if (target && target.matches('details.tqc-question')) {
      target.open = true;
      target.scrollIntoView({ block: 'start' });
    }
  };
  window.addEventListener('hashchange', openFromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash);
  else openFromHash();
  // Images above the question can shift it after the first scroll.
  if (document.readyState !== 'complete') window.addEventListener('load', openFromHash, { once: true });
})();
